import { createContext } from 'react';
import { User } from './entities/user';

export const UserContext = createContext<User|null>(null);
